/* eslint-disable no-restricted-globals */

export const ENVIRONMENT = process.env.NODE_ENV;
export const DEV_MODE = ENVIRONMENT === 'development';

export const ROOT_URL = process.env.REACT_APP_BASE_URL || (
  DEV_MODE ? 'http://127.0.0.1:5000' + '/api' : location.origin + '/api'
  // DEV_MODE ? 'http://127.0.0.1:5000' : location.origin
);

// ✅ 新增：SSE 的根地址（与上面不同的 host）
export const PROGRESS_ROOT_URL =
  process.env.REACT_APP_PROGRESS_BASE_URL ||
  (DEV_MODE ? 'http://localhost:5000/api' : location.origin + '/api');

export const ALLOW_CORS = process.env.REACT_APP_ALLOW_CORS || ENVIRONMENT === 'development';

export default {
  ENVIRONMENT,
  ROOT_URL,
  PROGRESS_ROOT_URL,
  ALLOW_CORS
};